import React, { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'

import { capitalize } from 'Helpers/layoutHelpers'
import { CampaignLanguagesProps } from './props'
import { GenresAndLanguagesRow, RowLabel } from './styles'

export const CampaignLanguages: FunctionComponent<CampaignLanguagesProps> = ({
  languages,
}) => {
  const { t } = useTranslation()
  return (
    <GenresAndLanguagesRow>
      <RowLabel>{t('scheduleCampaignPage.targetLanguage')}</RowLabel>
      {languages.map((el, id) => {
        const languageToRender = `${capitalize(el.name)}${
          id === languages.length - 1 ? '' : ', '
        }`
        return languageToRender
      })}
    </GenresAndLanguagesRow>
  )
}
